import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {deleteAdminUserRole} from '../../../../../actions/admin/manageaccessactions';
import TicketField from '../../../common/ticketfield';
import env from '../../../../../util/env';
import Loader from '../../../../Common/Loaders/loadingindicator';
import {labels} from '../../../../../util/uiconstants';
import MotifButton from '@ey/motif-react-wrapper/Button';
import {getLocalizedAPIError, validateTicketNumber} from '../../../common/util';
import Toast from '../../../../Common/Toast/Toast';

function DeleteRole(props) {
	const [errorMessage, setErrorMessage] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);

	const dispatch = useDispatch();

	const onTicketChanged = (e) => {
		setTicketNumber(e.target.value ?? '');
	};

	const onConfirmDeleteClick = () => {
		setIsSubmitClicked(true);
		if (!validateTicketNumber(ticketNumber)) {
			return;
		}

		const roleToDelete = props.roleToDelete;
		setIsLoading(true);
		let userId = location.pathname.split('/').at(-1);
		let deleteRoleUrl = '';
		let uriTicketNumber = encodeURIComponent(ticketNumber.trim());
		if (
			roleToDelete.countryIds &&
			roleToDelete.countryIds.length &&
			roleToDelete.subServiceLineId
		) {
			deleteRoleUrl =
				env.getURL('serviceUrlV2') +
				'admin/Users/' +
				userId +
				'/roles/' +
				roleToDelete.rbacRoleId +
				'/subservicelines/' +
				roleToDelete.subServiceLineId +
				'?ticketnumber=' +
				uriTicketNumber;
		} else {
			deleteRoleUrl =
				env.getURL('serviceUrlV2') +
				'admin/Users/' +
				userId +
				'/roles/' +
				roleToDelete.rbacRoleId +
				'?ticketnumber=' +
				uriTicketNumber;
		}

		dispatch(deleteAdminUserRole(deleteRoleUrl))
			.then(() => {
				props.onModalClose(true);
				setIsSubmitClicked(false);
			})
			.catch((e) => {
				setErrorMessage(getLocalizedAPIError(e));
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<DeleteRoleWrapper>
			<section
				className="toastMessage"
				style={{
					display: errorMessage && errorMessage.length > 0 ? 'block' : 'none'
				}}
			>
				<Toast variant="error" onClose={() => setErrorMessage(false)}>
					{errorMessage}
				</Toast>
			</section>
			{isLoading ? (
				<section className="delete-role-loader">
					<Loader show view="blockView" styleName="loadingstyle" />
				</section>
			) : (
				<section className="deleteRole-wrapper">
					<section className="deleteRole-content customScrollbar">
						<section
							className="title motif-body1-default-regular"
							aria-label=""
						>
							{props.roleToDelete.moduleName +
								' ' +
								props.roleToDelete.roleName}
						</section>
						<TicketField
							ticketNumber={ticketNumber}
							onTicketChanged={onTicketChanged}
							showValidation={isSubmitClicked}
						/>
					</section>
					<section className="modal-footer">
						<MotifButton
							variant="ghost"
							size="medium"
							onClick={() => {
								props.onModalClose(false);
							}}
						>
							{labels.cancel}
						</MotifButton>
						<MotifButton
							variant="primary"
							size="medium"
							disabled={ticketNumber.trim().length <= 0}
							onClick={onConfirmDeleteClick}
						>
							{labels.manageAccessDeleteRoleButton}
						</MotifButton>
					</section>
				</section>
			)}
		</DeleteRoleWrapper>
	);
}

const DeleteRoleWrapper = styled.section`
	.deleteRole-wrapper {
		display: grid;
		.title {
			padding: var(--spacing-x-large);
			padding-bottom: 0;
		}
		.deleteRole-content {
			min-height: var(--px-225);
		}
	}
	.delete-role-loader {
		padding: var(--px-24) !important;
	}
	//ticketstart
	.ticketdetail {
		padding: var(--spacing-x-large);
		.description {
			padding-bottom: var(--spacing-small);
		}
		.motif-form-field {
			width: var(--px-400);
			.motif-input {
				height: var(--px-44);
			}
		}
	}
	//ticketend
	.modal-footer {
		display: flex;
		justify-content: end;
		padding: 0;
		padding: var(--spacing-x-large);
		button {
			margin-left: var(--px-12);
		}
	}

	.motif-loader {
		height: var(--px-180) !important;
	}
`;

export default DeleteRole;
